import { observer } from 'mobx-react';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { ControlIcons } from 'owa-control-icons';
import MeetingRequestMessageType from 'owa-service/lib/contract/MeetingRequestMessageType';
import isMeetingCancellation from '../utils/isMeetingCancellation';
import formatMeetingTimeSpan from 'owa-timeformat/lib/utils/formatMeetingTimeSpan';
import { trace } from 'owa-trace';
import * as React from 'react';

const styles = require('./MeetingDetails.scss');
const classNames = require('classnames/bind').bind(styles);

export interface MeetingDetailsTimeProps {
    item: MeetingRequestMessageType;
    className?: string;
    iconStyle?: string;
}

@observer
export default class MeetingDetailsTime extends React.Component<MeetingDetailsTimeProps, {}> {
    render() {
        const { item, className, iconStyle } = this.props;

        if (!item) {
            return null;
        }

        const conditionalDetailsStyles = {
            cancelled: isMeetingCancellation(item.ItemClass),
        };

        return (
            <div className={classNames(styles.detailsRow, className)}>
                <Icon
                    className={classNames(styles.icon, styles.clockIcon, iconStyle)}
                    iconName={ControlIcons.Clock}
                />
                <span className={classNames(conditionalDetailsStyles)}>
                    {formatMeetingTimeSpan(
                        item.Start,
                        item.End,
                        !item.RecurrenceId /* ideally we would check CalendarItemType bu tit seems broken */
                            ? item.Recurrence
                            : undefined /* recurrenceId indicates instance */
                    )}
                    {this.tryRenderChangeHighlightTimeSpan(item)}
                </span>
            </div>
        );
    }

    private tryRenderChangeHighlightTimeSpan(
        meetingRequest: MeetingRequestMessageType
    ): JSX.Element {
        if (
            !meetingRequest.ChangeHighlights ||
            !(
                meetingRequest.ChangeHighlights.HasEndTimeChanged ||
                meetingRequest.ChangeHighlights.HasStartTimeChanged
            )
        ) {
            // Render nothing if the start and end time don't change
            return null;
        }

        const startTime = meetingRequest.ChangeHighlights.Start || meetingRequest.Start;
        const endTime = meetingRequest.ChangeHighlights.End || meetingRequest.End;

        if (new Date(startTime).getTime() > new Date(endTime).getTime()) {
            // Warn if the start time is newer than the end time, which could result in a weird formatted time span.
            trace.warn('MeetingDetails: start time is newer than end time');
        }

        return (
            <span className={styles.change}>
                {formatMeetingTimeSpan(startTime, endTime, meetingRequest.Recurrence)}
            </span>
        );
    }
}
